/**
 * Отправка ошибок интерфейса на API (POST /client-errors) для оповещений администраторам.
 * - Никаких персональных данных: URL передаётся без query и hash (в hash Telegram кладёт initData),
 *   сервер дополнительно вычищает токены и телефоны;
 * - не более 5 отчётов за загрузку страницы, одинаковые сообщения — один раз;
 * - выключено в режиме разработки и при VITE_ERROR_REPORTING=false;
 * - сбой отправки молча игнорируется.
 */
import { config } from '../config';

type Kind = 'error' | 'unhandledrejection' | 'render';
const MAX_REPORTS = 5;
const sent = new Set<string>();

export const errorReportingEnabled = () =>
  !import.meta.env.DEV && import.meta.env.VITE_ERROR_REPORTING !== 'false' && Boolean(config.apiUrl);

export function reportClientError(error: unknown, kind: Kind): void {
  if (!errorReportingEnabled()) return;
  const err = error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Non-error thrown');
  const key = `${kind}|${err.message}`;
  if (sent.has(key) || sent.size >= MAX_REPORTS) return;
  sent.add(key);
  const body = {
    app: 'miniapp',
    kind,
    message: err.message.slice(0, 2000) || err.name,
    stack: err.stack?.slice(0, 8000),
    url: `${location.origin}${location.pathname}`,
    release: import.meta.env.VITE_RELEASE || undefined,
    userAgent: navigator.userAgent.slice(0, 400),
  };
  try {
    void fetch(`${config.apiUrl}/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    /* мониторинг не должен ломать приложение */
  }
}

export function installGlobalErrorHandlers(): void {
  window.addEventListener('error', (e) => {
    // Ошибки загрузки ресурсов (картинки) не являются ошибками кода.
    if (e.error || e.message) reportClientError(e.error ?? e.message, 'error');
  });
  window.addEventListener('unhandledrejection', (e) => reportClientError(e.reason, 'unhandledrejection'));
}
